import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=38cd0540&scoped=true&"
import script from "./organization.vue?vue&type=script&lang=js&"
export * from "./organization.vue?vue&type=script&lang=js&"
import style0 from "./organization.vue?vue&type=style&index=0&id=38cd0540&prod&lang=scss&scoped=true&"
import style1 from "./organization.vue?vue&type=style&index=1&id=38cd0540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd0540",
  null
  
)

export default component.exports